import { useState, useEffect } from "react";
import "./pickup-question.css";
import Button from "../../../../ui/atoms/buttons/Button";
import InputText from "../../../../ui/atoms/inputs/input-text/InputText";
import InputSelect from "../../../../ui/atoms/inputs/input-select/InputSelect";
import Loading from "../../../../ui/atoms/loading/Loading";
import ChallengeThemeItem from "../../components/challenge-theme-item/ChallengeThemeItem";
import ChallengeThemeQuestionItem from "../challenge-theme-question-item/ChallengeThemeQuestionItem";
import NotFound from "../../../../ui/organisms/not-found/404";
import {
  onPickUpChallengeThemesWithPagination,
  onPickUpChallengeThemeQuestionByIdWithPagination,
} from "../../services/challengeTheme";
import { isEmpty, capitalizeAll } from "../../../../core/utils/helpers";
import { MdQuiz } from "react-icons/md";
import { GoClock } from "react-icons/go";
import moment from "moment";
import useAxiosPrivate from "../../../../app/providers/context-provider/useAxiosPrivate";

const PickUpQuestion = ({ setIsPickUpQuestion }) => {
  const axiosPrivate = useAxiosPrivate();

  const [isLoading, setIsLoading] = useState(false);
  const [isPickQuestionFrom, setIsPickQuestionFrom] = useState("system");
  const [isDetailsChallengeTheme, setIsDetailsChallengeTheme] = useState(false);

  const [searchSubject, setSearchSubject] = useState("");

  const challengesRowsPerPage = 10;
  const [challengesCurrentPage, setChallengesCurrentPage] = useState(1);
  const [challengesData, setChallengesData] = useState({});

  const questionsRowsPerPage = 10;
  const [questionsCurrentPage, setQuestionsCurrentPage] = useState(1);
  const [challengeQuestionsData, setChallengeQuestionsData] = useState({});

  const [currentSelectedChallengeTheme, setCurrentSelectedChallengeTheme] =
    useState({});

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const signal = controller.signal;

    const currentStream = null;

    const _localData = {
      pick_question_from: isPickQuestionFrom,
      stream_id: currentStream,
      subject: searchSubject,
      rows_per_page: challengesRowsPerPage,
      current_page: challengesCurrentPage,
    };
    onPickUpChallengeThemesWithPagination(axiosPrivate, _localData, signal).then(
      (response) => {
        const _data = response?.data;
        setChallengesData(_data);
      },
    );
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, [isPickQuestionFrom, challengesRowsPerPage, challengesCurrentPage]);

  const onSearchBySubject = () => {
    let isMounted = true;
    const controller = new AbortController();
    const signal = controller.signal;

    const currentStream = null;

    const _localData = {
      pick_question_from: isPickQuestionFrom,
      stream_id: currentStream,
      subject: searchSubject,
      rows_per_page: challengesRowsPerPage,
      current_page: challengesCurrentPage,
    };
    onPickUpChallengeThemesWithPagination(axiosPrivate, _localData, signal).then(
      (response) => {
        const _data = response?.data;
        setChallengesData(_data);
      },
    );
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  };

  useEffect(() => {
    onPickUpChallengeQuestions(currentSelectedChallengeTheme);
  }, [
    currentSelectedChallengeTheme,
    questionsRowsPerPage,
    questionsCurrentPage,
  ]);

  const onPickUpChallengeQuestions = (row) => {
    const _challenge_id = row?.id;
    let isMounted = true;
    const controller = new AbortController();
    const signal = controller.signal;

    const _localData = {
      pick_question_from: isPickQuestionFrom,
      challenge_id: _challenge_id,
      rows_per_page: questionsRowsPerPage,
      current_page: questionsCurrentPage,
    };
    onPickUpChallengeThemeQuestionByIdWithPagination(axiosPrivate, _localData, signal).then(
      (response) => {
        const _data = response?.data;
        setChallengeQuestionsData(_data);
        //
        setCurrentSelectedChallengeTheme(row);
        if (!isEmpty(row)) setIsDetailsChallengeTheme(true);
      },
    );
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  };

  return (
    <div className="pickup-question fade-in">
      <div className="w-full h-full p-xs">
        <div className="pickup-question-head d-flex justify-space-between">
          <div className="w-fit-content">
            <Button
              type={"button"}
              preferedStyle={"default"}
              title={"Go Back"}
              action={() => setIsPickUpQuestion(false)}
            />
          </div>
          <div className="w-fit-content d-flex gap-xs">
            <Button
              type={"button"}
              preferedStyle={
                isPickQuestionFrom === "system" ? "normal" : "default"
              }
              title={"Pick Up Questions design by system"}
              action={() => setIsPickQuestionFrom("system")}
            />
            <Button
              type={"button"}
              preferedStyle={
                isPickQuestionFrom !== "system" ? "normal" : "default"
              }
              title={"Pick Up Questions design by authors"}
              action={() => setIsPickQuestionFrom("author")}
            />
          </div>
          <div className="w-30 d-flex">
            <div className="w-full">
              <InputText
                name="search_subject"
                title="Research by a subject..."
                value={searchSubject}
                onChange={(e) => setSearchSubject(e.target.value)}
              />
            </div>
            {searchSubject && (
              <Button
                type={"button"}
                preferedStyle={"default"}
                title={"Search"}
                action={() => onSearchBySubject()}
              />
            )}
          </div>
          <div className="w-fit-content">
            <div className="pagination">
              <div className="p-wrapper">
                <button
                  className={
                    isEmpty(challengesData?.result_complements?.current_page) ||
                    challengesData?.result_complements?.current_page <= 1
                      ? "button is-inactive"
                      : "button is-active"
                  }
                  onClick={() =>
                    setChallengesCurrentPage((prev) =>
                      prev > 1 ? prev - 1 : 1,
                    )
                  }
                  disabled={
                    challengesData?.result_complements?.current_page === 1
                  }
                >
                  Previous
                </button>
                <span>
                  Page{" "}
                  {isEmpty(challengesData?.result_complements?.current_page)
                    ? 0
                    : challengesData?.result_complements?.current_page}{" "}
                  of{" "}
                  {isEmpty(challengesData?.result_complements?.total_pages)
                    ? 0
                    : challengesData?.result_complements?.total_pages}{" "}
                  pages.
                </span>
                <button
                  className={
                    challengesData?.result_complements?.current_page ===
                    challengesData?.result_complements?.total_pages
                      ? "button is-inactive"
                      : "button is-active"
                  }
                  onClick={() =>
                    setChallengesCurrentPage((prev) =>
                      prev <= challengesData?.result_complements?.total_pages
                        ? prev + 1
                        : prev,
                    )
                  }
                  disabled={
                    challengesData?.result_complements?.current_page ===
                    challengesData?.result_complements?.total_pages
                  }
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
        {isLoading ? (
          <Loading />
        ) : (
          <div className="pickup-question-body">
            {isEmpty(challengesData?.result) ? (
              <NotFound
                type={"data"}
                title={"No Challenge found!"}
                text={
                  isPickQuestionFrom === "system"
                    ? "No Challenge available yet."
                    : "No Challenge setup by an author available yet."
                }
                isBoutton={false}
              />
            ) : (
              challengesData?.result?.map((item, idx) => {
                return (
                  <ChallengeThemeItem
                    key={idx}
                    data={item}
                    onAction={() => {
                      onPickUpChallengeQuestions(item);
                    }}
                  />
                );
              })
            )}
          </div>
        )}
      </div>
      {isDetailsChallengeTheme && (
        <div className="w-full h-full details-challenge-theme fade-in p-xs">
          <div className="w-full h-full dct-wrapper p-xs">
            <div className="dct-head mb-xs">
              <div className="w-full d-flex justify-space-between">
                <div className="w-fit-content">
                  <h1>
                    {capitalizeAll(currentSelectedChallengeTheme?.title_en)}
                  </h1>
                  <p>
                    {capitalizeAll(
                      currentSelectedChallengeTheme?.challenge_theme_category_title_en,
                    )}
                  </p>
                </div>
                <div className="w-fit-content">
                  <Button
                    type={"button"}
                    preferedStyle={"default"}
                    title={"Close"}
                    action={() => setIsDetailsChallengeTheme(false)}
                  />
                </div>
              </div>
              <div className="w-full d-flex justify-space-between align-center">
                <div className="w-fit-content d-flex gap-lg align-center">
                  <div className="row">
                    <MdQuiz className="icon" />
                    <span>
                      {currentSelectedChallengeTheme?.total_questions}{" "}
                      {currentSelectedChallengeTheme?.total_questions > 1
                        ? "Questions"
                        : "Question"}
                    </span>
                  </div>
                  <div className="row">
                    <GoClock className="icon" />
                    <span>
                      Edited :{" "}
                      {moment(currentSelectedChallengeTheme?.updated_at).format(
                        "LLLL",
                      )}
                    </span>
                  </div>
                </div>
                <div className="w-20">
                  <InputSelect
                    name={"difficulty"}
                    error={null}
                    register={() => {}}
                    data={[
                      {
                        key: "beginner",
                        title: "Beginner level",
                        is_activated: false,
                      },
                      {
                        key: "intermediate",
                        title: "Intermediate level",
                        is_activated: false,
                      },
                      {
                        key: "advanced",
                        title: "Advanced level",
                        is_activated: false,
                      },
                    ]}
                    placeholder={"Question's Difficulty (level)"}
                  />
                </div>
                <div className="w-fit-content">
                  <div className="pagination">
                    <div className="p-wrapper">
                      <button
                        className={
                          challengeQuestionsData?.result_complements
                            ?.current_page === 1
                            ? "button is-inactive"
                            : "button is-active"
                        }
                        onClick={() =>
                          setQuestionsCurrentPage((prev) =>
                            prev > 1 ? prev - 1 : 1,
                          )
                        }
                        disabled={
                          challengeQuestionsData?.result_complements
                            ?.current_page === 1
                        }
                      >
                        Previous
                      </button>
                      <span>
                        Page {questionsCurrentPage} of{" "}
                        {
                          challengeQuestionsData?.result_complements
                            ?.total_pages
                        }{" "}
                        pages.
                      </span>
                      <button
                        className={
                          challengeQuestionsData?.result_complements
                            ?.current_page ===
                          challengeQuestionsData?.result_complements
                            ?.total_pages
                            ? "button is-inactive"
                            : "button is-active"
                        }
                        onClick={() =>
                          setQuestionsCurrentPage((prev) =>
                            prev <=
                            challengeQuestionsData?.result_complements
                              ?.total_pages
                              ? prev + 1
                              : prev,
                          )
                        }
                        disabled={
                          challengeQuestionsData?.result_complements
                            ?.current_page ===
                          challengeQuestionsData?.result_complements
                            ?.total_pages
                        }
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="dct-content">
              {challengeQuestionsData?.result?.map((question, idx) => {
                return (
                  <div className="w-50" key={idx}>
                    <ChallengeThemeQuestionItem
                      index={idx + 1}
                      question_data={{
                        question_id: question?.id,
                        qv_language: question?.qv_language,
                        released_status: question?.is_activated,
                        archived_status: question?.is_deleted,
                        created_at: question?.created_at,
                        type: question?.type,
                        difficulty: question?.difficulty,
                        points: question?.points,
                        timing: question?.timing,
                        random_answer_order: question?.random_answer_order,
                        qv_cover_audio: question?.qv_cover_audio,
                        qv_cover_image: question?.qv_cover_image,
                        qv_description: question?.qv_description,
                        qv_explanations: question?.qv_explanations,
                        qv_answers: question?.qv_answers,
                      }}
                      isCheckBox={true}
                      isActionsButton={false}
                      isDisplayLanguage={
                        isPickQuestionFrom === "system" ? true : false
                      }
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PickUpQuestion;
